import generateRandomString from '~/utils/generateRandomString';

/** Matches suffixes added by `buildSuggestedClonedVoucherName` (`-{8 alphanumeric}`). */
const TRAILING_CLONE_SUFFIX_RE = /^(.+)-[A-Za-z0-9]{8}$/;

/**
 * Removes one or more trailing clone suffixes so re-cloning suggests
 * `{root}-{newSuffix}` instead of `{root}-{old}-{old2}-{newSuffix}`.
 */
function voucherNameRootForCloneSuggestion(trimmedName: string): string {
  let current = trimmedName;
  for (;;) {
    const match = current.match(TRAILING_CLONE_SUFFIX_RE);
    if (!match) {
      return current;
    }
    current = match[1];
  }
}

/** Default suggested name when cloning: `{root without prior clone suffixes}-{random suffix}`. */
export function buildSuggestedClonedVoucherName(baseVoucherName: string): string {
  const base = voucherNameRootForCloneSuggestion(baseVoucherName.trim());
  if (!base) {
    return '';
  }
  return `${base}-${generateRandomString(8)}`;
}
